export const Shield = ({ width = '14', height = '14' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_215_9813)">
        <path
          d="M12.9361 2.87351L7.33605 0.073513C7.2388 0.0248486 7.13155 -0.000488281 7.0228 -0.000488281C6.91406 -0.000488281 6.8068 0.0248486 6.70955 0.073513L1.10955 2.87351C1.00404 2.92654 0.913632 3.00535 0.846697 3.10263C0.779762 3.19991 0.738472 3.31252 0.726653 3.43001C0.718953 3.50491 0.0539531 10.9669 6.73895 13.9398C6.82831 13.98 6.92518 14.0008 7.02315 14.0008C7.12113 14.0008 7.21799 13.98 7.30735 13.9398C13.9924 10.9669 13.3274 3.50561 13.3197 3.43001C13.3078 3.31243 13.2665 3.19975 13.1994 3.10245C13.1323 3.00515 13.0417 2.9264 12.9361 2.87351V2.87351ZM7.02315 12.5279C2.28555 10.2375 2.06085 5.34941 2.09935 3.94451L7.02315 1.48261L11.9435 3.94311C11.9701 5.33541 11.7139 10.2557 7.02315 12.5279V12.5279Z"
          fill="currentColor"
        />
        <path
          d="M8.6043 4.40515L6.9992 6.01025L5.3941 4.40515L4.4043 5.39495L6.0094 7.00005L4.4043 8.60515L5.3941 9.59495L6.9992 7.98985L8.6043 9.59495L9.5941 8.60515L7.989 7.00005L9.5941 5.39495L8.6043 4.40515Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_215_9813">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
